import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { style: {"flex":"1"} }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { style: {"flex":"1"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Title, {
      class: "mb-4",
      label: _ctx.$t('clientManagement.registrationForm.payment.title'),
      fontSize: 20
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('clientManagement.managementDetail.paymentMethod'),
        asterisk: "",
        fontSize: 14,
        style: {"flex":"1"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CustomDropdown, {
            class: "mt-2",
            placeholder: _ctx.$t('clientManagement.registrationForm.payment.selectPaymentMethod'),
            customValueStyle: "text-sm",
            customOptionStyle: "text-sm",
            selectedItem: _ctx.formModel.paymentMethod,
            options: _ctx.paymentMethodList,
            modelValue: _ctx.formModel.paymentMethod,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formModel.paymentMethod = $event))
          }, null, 8, ["placeholder", "selectedItem", "options", "modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _hoisted_2,
      _hoisted_3
    ])
  ]))
}